import React, { useRef } from "react";

function OrderRequirements(pdf) {

  const pdfRef = useRef(JSON.parse(pdf.pdf));

  return (
    <div className={"order-requirements-container"}>
      {pdfRef.current.PdfExists && <iframe src={pdfRef.current.PdfUrl} className={"pdf-attached"}/>}
      {!pdfRef.current.PdfExists && <p className={"no-pdf-attached"}>No requirements pdf attached.</p>}
    </div>
  );
}

export default OrderRequirements;